import SessionManager from "../Context/SessionManager";
import SessionModal from "../PopModal/PopupGlobel";
import { useIdleLogout } from "../Context/useIdleLogout";
import { Outlet } from "react-router";
function AppContent() {
  const {
    setShowSessionDialog,
    showSessionDialog,
    continueSession,
    logout,
  } = useIdleLogout();

  return (
    <>
      <SessionManager />

      <Outlet />

      {showSessionDialog && (
        <SessionModal
          approveAction={continueSession}
          cancelAction={()=>{setShowSessionDialog(false);logout();}}
          btnApproveTitle="الاستمرار بالجلسة"
          btnCancelTitle="تسجيل الخروج"
          title="ستنتهي الجلسة خلال دقيقة"
          popupType={1}
          size="lg"
          btnIcon="play_circle"
        >
<h3>هل تريد الاستمرار بالجلسة ؟<span className="material-symbols-outlined text-2xl">
  timer_off
</span></h3></SessionModal>
      )}
    </>
  );
}

export default AppContent;
